import React from "react";
import ProjectNav from "./components/project-nav.component";
import Authentication from "./config-authentication.component";
import ContentCMS from "./config-content-cms.component";
import EHRIntegration from "./config-ehr-integration.component";
import EventTriggers from "./config-community.component";
import Modules from "./config-modules.component";

const ConfigProjectDetail: React.FC = () => {
  const [openTab, setOpenTab] = React.useState(1);

  return (
    <div className="flex flex-wrap overflow-y-auto">
      <div className="w-full">
        <ProjectNav openTab={openTab} setOpenTab={setOpenTab} />

        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 rounded">
          <div className="px-4 py-5 flex-auto">
            <div className="tab-content tab-space">
              <div
                className={openTab === 1 ? "block" : "hidden"}
                id="translation"
              >
                <EHRIntegration />
              </div>
              <div className={openTab === 2 ? "block" : "hidden"} id="glossary">
                <Authentication />
              </div>
              <div
                className={openTab === 3 ? "block" : "hidden"}
                id="languages"
              >
                <ContentCMS />
              </div>
              {/* <div className={openTab === 4 ? "block" : "hidden"} id="files">
                <EventTriggers />
              </div> */}
              <div
                className={openTab === 4 ? "block" : "hidden"}
                id="Collaborators"
              >
                <Modules />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfigProjectDetail;
